import { create } from 'zustand';
import type { Attachment } from 'features/chat/types/chat';

interface AssistantFileViewerState {
  file: Attachment | null;
  isExpanded: boolean;
  openFile: (file: Attachment) => void;
  closeFile: () => void;
  setExpanded: (isExpanded: boolean) => void;
  toggleExpanded: () => void;
}

export const useAssistantFileViewerStore = create<AssistantFileViewerState>((set) => ({
  file: null,
  isExpanded: false,
  openFile: (file) => set({ file, isExpanded: false }),
  closeFile: () => set({ file: null, isExpanded: false }),
  setExpanded: (isExpanded) => set({ isExpanded }),
  toggleExpanded: () => set((state) => ({ isExpanded: !state.isExpanded })),
}));
